export default "__VITE_ASSET__OcS6UYn4__"